// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linkSecondary__aa4 {
  color: inherit;
  border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/common/navigation/navigation-link.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".linkSecondary {\n  color: inherit;\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkSecondary": `linkSecondary__aa4`
};
export default ___CSS_LOADER_EXPORT___;
